export default {
  vote: {
    vote: 'تصويت',
    noVoteQuestionsAvailable: 'لا توجد أسئلة تصويت متاحة',
    yes: 'نعم',
    no: 'لا',
    noVote: 'امتنع عن التصويت',
    'no vote': 'امتنع عن التصويت',
    null: 'لم يصوت',
    submit: 'إرسال',
    voteResults: 'نتائج التصويت',
    question: 'السؤال',
    excluded: 'مستبعد',
    clause: 'البند',
    excludedUser: 'أنت مستبعد من هذا البند',
    voteResultsByShareholder: 'نتائج التصويت حسب المساهمين',
    noResults: 'لا توجد نتائج',
    name: 'الاسم',
    download: 'تنزيل',
    votingResultsByShareholder: 'نتائج التصويت حسب المساهمين',
    next: 'التالي',
    meetings: 'الاجتماعات',
    meetingDetails: 'تفاصيل الاجتماع',
    pointDescription: 'وصف النقطة',
    showVoteByOwnership: 'عرض التصويت حسب نسبة الملكية',
    showVoteByMember: 'عرض التصويت حسب العضو',
    voteCount: 'عدد الأصوات',
    totalShares: 'إجمالي الأسهم',
    ownership: 'الملكية',
    voteDetails: 'تفاصيل التصويت',
    shareholder: 'المساهم',
    shareholders: 'الشركاء',
    results: 'النتائج',
    percentage: 'النسبة',
  },
};
